import { memo } from 'react';
import { VoteIndicator as VoteIndicatorIcon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Tooltip } from '@mentimeter/ragnar-ui/tooltip';
import { IndicationNumber } from '../IndicationNumbers';
import { Indication } from '../Indication';
import { getCompactNumberFormat } from './getCompactNumberFormat';

interface RespondentsIndicatorProps {
  respondedCount: number;
  joinCount: number;
}

export const RespondentsIndicator = memo<RespondentsIndicatorProps>(
  ({ respondedCount, joinCount }: RespondentsIndicatorProps) => {
    const indicationValue =
      joinCount > 0 ? (
        <>
          <Text color="inherit" lineHeight="inherit" fontWeight="semiBold">
            {getCompactNumberFormat(respondedCount)}
          </Text>
          <Text
            color="inherit"
            lineHeight="inherit"
            fontWeight="regular"
            extend={() => ({
              opacity: 0.55,
            })}
          >
            {' '}
            /{' '}
          </Text>
          <Text color="inherit" lineHeight="inherit" fontWeight="semiBold">
            {getCompactNumberFormat(joinCount)}
          </Text>
        </>
      ) : (
        getCompactNumberFormat(respondedCount)
      );

    const shouldShow = joinCount > 0 || respondedCount > 0;

    // TODO: translate these strings
    const tooltipText =
      joinCount > 0
        ? 'Participants responded / active'
        : 'Participants responded';

    return (
      <Tooltip
        sideOffset={20}
        withPortal={false}
        align="end"
        trigger={
          <Box data-testid="vote-indicator">
            <Indication>
              <IndicationNumber
                value={{
                  customComponent: indicationValue,
                  shouldShow,
                }}
              />
              <VoteIndicatorIcon size={3} color="text" />
            </Indication>
          </Box>
        }
      >
        {shouldShow && tooltipText}
      </Tooltip>
    );
  },
);
